import {
  Grid, TextField, InputAdornment, Autocomplete, alpha, useTheme
} from '@mui/material';
import { AttachMoney as MoneyIcon } from '@mui/icons-material';
import { SectionPaper, SectionTitle } from './styledComponents';

const PaymentTermsSection = ({ invoice, onUpdate, canEdit = true }) => {
  const theme = useTheme();

  const inputSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: 3,
      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
      background: 'white',
      opacity: canEdit ? 1 : 0.6,
      '& fieldset': { border: 'none' }
    }
  };

  return (
    <SectionPaper sx={{ width: '100%', mt: 3 }}>
      <SectionTitle variant="h6"><MoneyIcon />Payment Terms</SectionTitle>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            value={invoice.payment_terms || ''}
            onChange={(_, newValue) => canEdit && onUpdate({ payment_terms: newValue || '' })}
            onInputChange={(_, newInputValue) => canEdit && onUpdate({ payment_terms: newInputValue || '' })}
            disabled={!canEdit}
            options={['Due on Receipt', 'Net 10', 'Net 15', 'Net 30', 'Net 45', 'Net 60', 'Net 90', 'COD', 'Prepaid']}
            renderInput={(params) => <TextField {...params} label="Payment Terms" sx={inputSx} />}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            value={invoice.payment_method || ''}
            onChange={(_, newValue) => canEdit && onUpdate({ payment_method: newValue || '' })}
            onInputChange={(_, newInputValue) => canEdit && onUpdate({ payment_method: newInputValue || '' })}
            disabled={!canEdit}
            options={['Check', 'Credit Card', 'Bank Transfer', 'Wire Transfer', 'Cash', 'PayPal', 'Other']}
            renderInput={(params) => <TextField {...params} label="Payment Method" placeholder="Wire Transfer" sx={inputSx} />}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Late Fee"
            type="number"
            value={invoice.late_fee_rate || ''}
            onChange={(e) => canEdit && onUpdate({ late_fee_rate: e.target.value })}
            fullWidth disabled={!canEdit}
            inputProps={{ min: 0, max: 100, step: 0.1 }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
              sx: { borderRadius: 3, border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`, background: 'white', opacity: canEdit ? 1 : 0.6, '& fieldset': { border: 'none' } }
            }}
            helperText="Monthly late fee rate"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Early Payment Discount"
            type="number"
            value={invoice.early_payment_discount || ''}
            onChange={(e) => canEdit && onUpdate({ early_payment_discount: e.target.value })}
            fullWidth disabled={!canEdit}
            inputProps={{ min: 0, max: 100, step: 0.1 }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
              sx: { borderRadius: 3, border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`, background: 'white', opacity: canEdit ? 1 : 0.6, '& fieldset': { border: 'none' } }
            }}
            helperText="Discount for early payment"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Early Payment Days"
            type="number"
            value={invoice.early_payment_days || ''}
            onChange={(e) => canEdit && onUpdate({ early_payment_days: e.target.value })}
            fullWidth disabled={!canEdit}
            inputProps={{ min: 0, step: 1 }}
            InputProps={{
              sx: { borderRadius: 3, border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`, background: 'white', opacity: canEdit ? 1 : 0.6, '& fieldset': { border: 'none' } }
            }}
            helperText="Days for discount"
          />
        </Grid>
      </Grid>
    </SectionPaper>
  );
};

export default PaymentTermsSection;
